import { db } from "@/fstore";
import { returnRandomKey } from "@/utils/randomKey";
import router from "@/router";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    deleteShow({ dispatch }, show_object) {
      console.log("deleteShow");
      // Note, the show_object *needs* to contain the entire show.
      // In most cases however, the show_object will contain the entire document.
      var show_key = show_object.key;
      var updated_at = new Date().getTime();
      // Add update time.
      show_object.updated_at = updated_at;
      show_object.deleted = true;
      show_object.deleted_at = updated_at;
      if (!show_object.privateLinkKey) {
        show_object.privateLinkKey = returnRandomKey();
      }
      // Make privacyState = privacySelected.
      show_object.privacyState = "private";
      show_object.published = false;
      dispatch("showList/removeShowFromList", show_key, { root: true });
      db.collection("editor_shows")
        .doc(show_key)
        .update(show_object)
        .then(function() {
          console.log("updateShow", "success");
          router.push({ name: "shows" });

          dispatch("showsJson/publishShowByKey", show_key, {
            root: true
          });
        });
    }
  }
};
